import type { DataImportsResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDataImportsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDataImportsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetDataImports = createQueryHook<
  Record<string, never>,
  DataImportsResponseRow[],
  GetDataImportsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.dataImport.dataImports.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    data_import: data,
  }),
  graphqlDocument: GetDataImportsDocument,
  // Mounted by the settings list tab; keep Apollo dedup working under cache-first.
  graphqlFetchPolicy: 'cache-first',
});
